// Copyright 2022-2023 @Polkasafe/polkaSafe-ui authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

// Copyright 2022-2023 @Polkasafe/polkaSafe-ui authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

import React from 'react';

const TermsAndCondition = () => {
	return (
		<div className='h-[70vh] bg-bg-main rounded-lg m-auto flex'>
			<div className='w-fit text-sm m-5 overflow-auto [&::-webkit-scrollbar]:hidden'><p className='text-white'><p>Welcome to <span className='font-bold'>PolkaSafe!</span></p>
				<p className='my-2'>These terms and conditions outline the rules and regulations for the use of Company Name&apos;s Website, located at Website.com.</p>

				<p>By accessing this website we assume you accept these terms and conditions. Do not continue to use Website Name if you do not agree to take all of the terms and conditions stated on this page.</p>

				<p className='my-2'>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: “Client”, “You” and “Your” refers to you, the person log on this website and compliant to the Company&apos;s terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client&apos;s needs in respect of provision of the Company&apos;s stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.</p>

				<p className="font-bold">Cookies</p>
				<p className="my-2">We employ the use of cookies. By accessing Website Name, you agreed to use cookies in agreement with the Company Name&apos;s Privacy Policy.</p>
				<p>Most interactive websites use cookies to let us retrieve the user&apos;s details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.
				</p>

				<p className="font-bold my-2">License</p>

				<p>Unless otherwise stated, Company Name and/or its licensors own the intellectual property rights for all material on Website Name. All intellectual property rights are reserved. You may access this from Website Name for your own personal use subjected to restrictions set in these terms and conditions.</p>

				<p className='my-2'>You must not:</p>

				<p>Republish material from Website Name <br />
                    Sell, rent or sub-license material from Website Name <br />
                    Reproduce, duplicate or copy material from Website Name <br />
                    Redistribute content from Website Name <br />
                    This Agreement shall begin on the date hereof.
				</p>
			</p>
			</div>
		</div>
	);
};

export default TermsAndCondition;